import * as React from "react";
import { wrapper, message } from "./SearchMessage.module.scss";

export const Wrapper: React.FC<any> = (props) => {
  return (
    <div className={wrapper} role="alert" aria-live="assertive">
      {props.children}
    </div>
  );
};

export const Message: React.FC<any> = (props) => {
  return (
    <h3 className={`${message} pe-3`} id={props.id}>
      {props.children}
    </h3>
  );
};
